import AccordionItemHandler from '@/components/forms/new/AccordionItemHandler';
import EntityAttributeField from './formFields/EntityAttributeField';

const CompanyCustomAttributes = ({ darkMode, errors, touched }) => {
    return (
        <AccordionItemHandler key="custom" index={0} label="Custom Attributes">
            {[1, 2, 3].map((num) => (
                <EntityAttributeField
                    key={`platformAttribute${num}`}
                    errors={errors}
                    touched={touched}
                    darkMode={darkMode}
                    number={num}
                />
            ))}
        </AccordionItemHandler>
    );
};

export default CompanyCustomAttributes;
